var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8125 33.7502H6.125C3.32562 33.7502 0.5 31.6239 0.5 26.8764V17.4264C0.539426 13.118 2.15267 8.97264 5.03596 5.77096C7.91924 2.56927 11.8736 0.532186 16.1544 0.0433134C18.5701 -0.132047 20.9952 0.214654 23.2649 1.05986C25.5347 1.90506 27.596 3.22896 29.3086 4.9416C31.0212 6.65423 32.3451 8.71547 33.1903 10.9852C34.0355 13.255 34.3822 15.6801 34.2069 18.0958C33.7174 22.3783 31.6786 26.334 28.4746 29.2175C25.2706 32.1009 21.1228 33.7131 16.8125 33.7502ZM38 17.0252H37.9775C37.9775 17.4696 37.9775 17.9139 37.955 18.3602C37.2313 28.5002 27.9631 37.0839 17.5325 37.4646V37.4927C18.8461 39.771 20.7357 41.6639 23.0117 42.9816C25.2877 44.2993 27.8701 44.9954 30.5 45.0002H39.875C41.3668 45.0002 42.7976 44.4076 43.8525 43.3527C44.9074 42.2978 45.5 40.867 45.5 39.3752V30.0002C45.4973 27.3698 44.8029 24.7863 43.4865 22.5089C42.1701 20.2316 40.278 18.3404 38 17.0252Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.b4d2b0e817024b0a7a1b5744ab12c25e.svg";
export { ForwardRef as ReactComponent };